export const UserAddresses = () => {
  return <div>UserAddresses</div>;
};
